import { registerRootComponent } from "expo"
import App from "./src/App"

// Register the main component
registerRootComponent(App)
